/* eslint-disable no-undef */
const ENV = process.env.REACT_APP_ENV || 'uat';

export const configuration = {
  mode: 'prod',
  version: '1.0.3',
  webServiceEndpoint: {
    dev: 'https://services-dev.prudential.co.th/hrportalService',
    uat: 'https://services-uat.prudential.co.th/hrportalService',
    prod: 'https://services.prudential.co.th/hrportalService',
  },
  appPath: {
    dev: '',
    uat: '',
    prod: '',
  },
  callback: {
    dev: '/hrportal',
    uat: '/hrportal',
    prod: '/hrportal',
  },
  defaultLanguage: 'TH',
  app: {
    gaURL: {
      dev: 'UA-113409896-1',
      uat: 'UA-113415993-1',
      prod: 'UA-116596664-1',
    },
    mixpanel: {
      dev: '424a1a3501172c3eab7c4b44b5e1d457',
      uat: '424a1a3501172c3eab7c4b44b5e1d457',
      prod: 'e17470858e393c4efa79671bc3172194',
    },
  },
};
